<script>
import con from '@services/connection'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'
import { getInitials } from '@utils/Format'

export default {
  props: {
    item: Object,
    dados: Object,
    hideDescription: Boolean,
  },
  data() {
    return {
      getInitials,
    }
  },
  computed: {
    isDark() {
      return this.item.color === 'dark'
    },
    isPrimary() {
      return this.item.color === 'primary'
    },
  },
  methods: {
    goTo(name) {
      if (name && typeof name === 'string') {
        this.$emit('goto', name)
      }
    },
  },
}
</script>

<template>
  <div
    class="text-center d-flex flex-column align-items-center justify-content-center"
  >
    <v-menu offset-y open-on-hover :disabled="!item.actions">
      <template v-slot:activator="{ on }">
        <div style="background-color: white" v-on="on">
          <div style="position: relative">
            <BaseButton
              small
              :dark="isDark"
              :primary="isPrimary && !item.disabled"
              :outline="!dados[item.checked.attr] && !item.disabled"
              :disabled="item.disabled"
              :secondary="item.disabled"
              style="white-space: initial"
              @click="goTo(item.go_to)"
            >
              {{ item.title }}
            </BaseButton>
            <v-icon
              v-if="dados[item.checked.attr]"
              small
              style="
                color: white;
                position: absolute;
                right: 0px;
                top: 0;
                text-align: center;
              "
            >
              mdi-check-circle-outline
            </v-icon>
          </div>
        </div>
      </template>
      <div v-if="!hideDescription" class="d-flex flex-column bg-white">
        <div
          v-for="act in item.actions"
          style="position: relative"
          class="m-0 mt-2"
        >
          <BaseButton
            small
            :dark="isDark"
            :primary="isPrimary"
            :outline="!dados[act.checked.attr]"
          >
            {{ act.text }}
          </BaseButton>
          <v-icon
            v-if="dados[act.checked.attr]"
            small
            style="
              color: white;
              position: absolute;
              right: 0px;
              top: 0;
              text-align: center;
            "
          >
            mdi-check-circle-outline
          </v-icon>
        </div>
      </div>
    </v-menu>
    <v-avatar hidden size="32" :color="item.color" class="mt-1">
      <v-avatar
        v-if="!dados[item.checked.attr]"
        size="28"
        color="white"
      ></v-avatar>
      <span v-if="dados[item.checked.attr]" class="white--text">
        {{ getInitials(item.checked.name) }}
      </span>
    </v-avatar>
    <div v-if="!hideDescription" style="height: 48px">
      <p
        v-if="dados[item.subtitle_dark.attr] || item.subtitle_dark.name"
        class="mb-0"
      >
        <small>
          {{ dados[item.subtitle_light.attr] || item.subtitle_light.name }}
        </small>
      </p>
      <small>
        <strong>
          {{ dados[item.subtitle_dark.attr] || item.subtitle_dark.name }}
        </strong>
      </small>
    </div>
  </div>
</template>

<style lang="sass" scope>
i.dark--text
  color: var(--dark) !important
.v-avatar.dark
  background-color: var(--dark) !important
</style>
